import {
  COMMENT_ADDED_SUBSCRIBED_SUCCESS, LOGIN_USER_SUCCESS, LOGOUT_USER_SUCCESS,
} from '../../../constants/system/actions';

const commentsReducer: Reducer = (
  state: ReducerState = {
    commentActiveSubscription: null,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case COMMENT_ADDED_SUBSCRIBED_SUCCESS:
      return {
        ...state,
        commentActiveSubscription: action.subscription,
      };
    case LOGIN_USER_SUCCESS:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        commentActiveSubscription: null,
      };
    default:
      return state;
  }
};

export default commentsReducer;
